import { render, staticRenderFns } from "./MissingModuleModal.vue?vue&type=template&id=2ed6b1bf&scoped=true"
import script from "./MissingModuleModal.vue?vue&type=script&lang=ts"
export * from "./MissingModuleModal.vue?vue&type=script&lang=ts"
import style0 from "./MissingModuleModal.vue?vue&type=style&index=0&id=2ed6b1bf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6b1bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed6b1bf')) {
      api.createRecord('2ed6b1bf', component.options)
    } else {
      api.reload('2ed6b1bf', component.options)
    }
    module.hot.accept("./MissingModuleModal.vue?vue&type=template&id=2ed6b1bf&scoped=true", function () {
      api.rerender('2ed6b1bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MissingModuleModal.vue"
export default component.exports